import { EncounterStatusVo, PatientVo } from '../api-client.service';

export function getPdfPasswordForEncounter(encounter: EncounterStatusVo): string {
  const potentialPassword = getPotentialPasswordForPdf(encounter.PatientEventDetails.Patient);
  if (potentialPassword) {
    return potentialPassword;
  }
  return null;
}

export function getEmailPrompt(): string {
  return (
    '<b>Your PDF is password protected</b>.<br>' +
    '<b>Password: </b><br>' +
    'Please use your <b>South African ID number</b> or <b>passport number</b> as the password.<br>' +
    'If this is unavailable, the <b>main member’s ID number</b> has been used as the password instead.<br><br>' +
    '<b>How to View:</b><br>' +
    '1. Open the attached PDF.<br>' +
    '2. When prompted, enter the relevant ID or passport number as your password.<br><br>'
  );
}

export function getPotentialPasswordForPdf(patient: PatientVo): string | undefined {
  return (
    patient.PatientDetails.IdentityNo ||
    patient.PatientDetails.PassportNo ||
    patient.PatientAccountDetails.MedicalAidMainMemberDetails.IdentityNo
  );
}
